import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import MultiSelectField from "../../common/profile/MultiSelectField";
/******************************************************
 * Filtres de recherche des consultants
 ******************************************************/
export default function ConsultantFilters({
    filters,
    natureActivityTypes = [],
    activityProfs = [],
    specialites = [],
    wilayas = [],
    onChange,
    onSearch,
    onReset,
    onActivityProfsChange,
    onSpecialitesChange

}) {

    /******************************************************
     * Internationalisation
     ******************************************************/
    const { t } = useTranslation();
    /******************************************************
     * Style React Select
     ******************************************************/
    const selectStyle = {
        control: (base) => ({
            ...base,
            minHeight: 46,
            borderRadius: 10,
            borderColor: "#ced4da",
            boxShadow: "none",
            "&:hover": {
                borderColor: "#198754"

            }

        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999
        })
    };
    /******************************************************
     * Liste des expériences
     ******************************************************/
    const experiences = [
        {
            id: 1,
            libelle: t("consultant.filters.experience1")
        },
        {
            id: 3,
            libelle: t("consultant.filters.experience3")
        },
        {
            id: 5,
            libelle: t("consultant.filters.experience5")
        },
        {
            id: 10,
            libelle: t("consultant.filters.experience10")
        },
        {
            id: 20,
            libelle: t("consultant.filters.experience20")
        }
    ];

    const { i18n } = useTranslation();
    const getWilayaName = (wilaya) => {
        if (!wilaya) {
            return "";
        }
        switch (i18n.language) {
            case "ar":
                return wilaya.wilayaArab || wilaya.wilaya;
            case "en":
                return wilaya.wilayaAng || wilaya.wilaya;
            default:
                return wilaya.wilaya;
        }
    };
 
  
    return (
        <div className="consultant-filters card shadow-sm border-0">
            {/*==============================================*/}
            {/* Entête                                       */}
            {/*==============================================*/}

            <div className="card-header bg-success text-white">
                <h5 className="mb-0">
                    <i className="bi bi-funnel-fill me-2"></i>
                    {t("consultant.filters.title")}
                </h5>
            </div>
            <div className="card-body">
                {/*==============================================*/}
                {/* Type consultant                               */}
                {/*==============================================*/}

                <div className="mb-4">
                    <label className="form-label fw-bold">
                        {t("consultant.filters.type")}
                    </label>
                    <Select
                        styles={selectStyle}
                        placeholder={t("consultant.filters.choose")}
                        isClearable
                        options={natureActivityTypes}
                        value={
                            natureActivityTypes.find(
                                x => x.id === filters.natureActivityType
                            ) || null
                        }

                        getOptionValue={(o) => o.id}
                        getOptionLabel={(o) => o.libelle}
                        onChange={(item) =>
                            onChange(
                                "natureActivityType",
                                item ? item.id : ""
                            )
                        }
                    />
                </div>

                {/*==============================================*/}
                {/* Activités professionnelles                    */}
                {/*==============================================*/}

                <MultiSelectField

                    label={t("consultant.filters.activities")}
                    options={activityProfs}
                    value={filters.activityProfs}
                    field="activityProf"
                    optionValue="id"
                    optionLabel="activityProf"
                    onChange={onActivityProfsChange}
                    isDisabled={!filters.natureActivityType}

                />

                {/*==============================================*/}
                {/* Spécialités                                  */}
                {/*==============================================*/}
                <MultiSelectField

                    label={t("consultant.filters.specialities")}
                    options={specialites}
                    value={filters.specialites}
                    field="specialite"
                    optionValue="id"
                    optionLabel="specialities"
                    onChange={onSpecialitesChange}
                    isDisabled={!filters.natureActivityType}
                />

                {/*==============================================*/}
                {/* Wilaya                                       */}
                {/*==============================================*/}
                <div className="mt-4">
                    <label className="form-label fw-bold">
                        {t("consultant.filters.wilaya")}
                    </label>
                    <Select

                        styles={selectStyle}
                        isClearable
                        placeholder={t("consultant.filters.allWilayas")}
                        options={wilayas}
                        value={
                            wilayas.find(
                                w => w.id === filters.wilaya
                            ) || null
                        }
                        getOptionValue={(o) => o.id}
                        getOptionLabel={(o) =>
                            `${o.codeWilaya} - ${getWilayaName(o)}`
                        }
                        onChange={(item) =>
                            onChange(
                                "wilaya",
                                item ? item.id : ""
                            )
                        }
                    />
                </div>

                {/*==============================================*/}
                {/* Expérience                                   */}
                {/*==============================================*/}
                <div className="mt-4">
                    <label className="form-label fw-bold">
                        {t("consultant.filters.experience")}
                    </label>
                    <Select
                        styles={selectStyle}
                        isClearable
                        placeholder={t("consultant.filters.all")}
                        options={experiences}
                        value={
                            experiences.find(
                                e => e.id === filters.experience
                            ) || null
                        }
                        getOptionValue={(o) => o.id}
                        getOptionLabel={(o) => o.libelle}
                        onChange={(item) =>
                            onChange(
                                "experience",
                                item ? item.id : ""
                            )
                        }
                    />
                </div>
                {/*==============================================*/}
                {/* Disponible immédiatement                      */}
                {/*==============================================*/}
                <div className="form-check mt-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={filters.available}
                        onChange={(e) =>
                            onChange(
                                "available",
                                e.target.checked
                            )
                        }
                        id="available"
                    />
                    <label
                        htmlFor="available"
                        className="form-check-label"
                    >
                        {t("consultant.filters.available")}
                    </label>
                </div>
                {/*==============================================*/}
                {/* Boutons                                      */}
                {/*==============================================*/}

                <div className="d-grid gap-2 mt-4">
                    <button
                        className="btn btn-success"
                        onClick={onSearch}
                    >
                        <i className="bi bi-search me-2"></i>
                        {t("button.search")}
                    </button>
                    <button
                        className="btn btn-outline-secondary"
                        onClick={onReset}
                    >
                        <i className="bi bi-arrow-clockwise me-2"></i>
                        {t("button.reset")}
                    </button>
                </div>
            </div>
        </div>
    );
}